module.exports = __webpack_public_path__ + "media/location-service_de_desktop.c40c36cc.webm";